import React from 'react';

import PropTypes from 'prop-types';
import { Flex, Text, Icon, rem } from '@feast-it/pesto';
import * as Styled from './styles';

export const CustomInput = React.forwardRef(({ value, onClick }, ref) => {
  return (
    <Flex
      flexDirection="row"
      borderBottom={`${rem(2)} dotted white`}
      ref={ref}
      onClick={onClick}
    >
      <Text
        fontFamily="heading"
        fontSize={{ _: 'headingLargeMobile', m: 'headingLarge' }}
        lineHeight={{ _: 'headingLarge', m: 'headingLargeMobile' }}
        color="white"
      >
        {value ? value : 'Select a date'}
      </Text>
      <Icon
        mt={{ _: 6, m: 3 }}
        ml={3}
        name="ChevronDown"
        color="white"
        size={14}
      />
    </Flex>
  );
});

CustomInput.propTypes = {
  value: PropTypes.string,
  onClick: PropTypes.func,
  isExpanded: PropTypes.bool,
};

CustomInput.displayName = 'CustomInput';

export const CustomBoxInput = React.forwardRef(
  ({ value, onClick, color, error }, ref) => {
    return (
      <Flex alignItems="center" ref={ref} error={error} onClick={onClick}>
        <Styled.Input width={{ _: rem(343), m: rem(400) }} p={{ _: 3, m: 2 }}>
          <Icon width={24} height={24} name="Calendar" color={color} mr={4} />

          {value && (
            <Text
              fontFamily="body"
              color="blueDark"
              fontSize={{ _: 'body', m: 'large' }}
            >
              {value}
            </Text>
          )}

          {!value && <Styled.Placeholder>Select a date</Styled.Placeholder>}
        </Styled.Input>
      </Flex>
    );
  }
);

CustomBoxInput.propTypes = {
  value: PropTypes.string,
  onClick: PropTypes.func,
  color: PropTypes.string,
  error: PropTypes.bool,
};

CustomBoxInput.displayName = 'CustomBoxInput';
